import { Subject } from 'rxjs';

const subject = new Subject();

export const createTopicService = {
  emitReload: val => subject.next(val),
  reload: () => subject.asObservable()
};